var _path, _g, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 100,
    viewBox: "0 0 87 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.4686 0L86.9565 25L86.9565 75L43.4686 100L0 75L0 25L43.4686 0Z",
    fill: "#BEAEFF",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9968_3792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.3578 38.9623L45.6775 34.282C44.3788 32.9833 42.3265 32.9528 41.0909 34.1884L23.1186 52.1607C21.883 53.3963 21.9247 55.4374 23.2234 56.7361L27.9037 61.4164C29.1393 60.1808 31.1921 60.2342 32.4792 61.5212C33.7662 62.8083 33.8196 64.8611 32.5728 66.1079L37.253 70.7882C38.5401 72.0753 40.6041 72.1174 41.8397 70.8818L59.812 52.9095C61.0476 51.6739 61.0054 49.6099 59.7184 48.3229L55.0381 43.6426C53.8025 44.8782 51.7385 44.8361 50.4514 43.549C49.1643 42.2619 49.1222 40.1979 50.3578 38.9623ZM46.403 39.5005C45.8736 41.6446 46.4849 44.0755 48.2049 45.7955C49.9249 47.5155 52.3558 48.1268 54.4999 47.5974L57.4718 50.5694L39.4996 68.5417L36.5276 65.5697C37.0569 63.4257 36.4457 60.9947 34.7257 59.2747C32.994 57.543 30.586 56.9322 28.4419 57.4616L25.4587 54.5008L43.431 36.5286L46.403 39.5005ZM43.8522 57.1686L46.0988 54.9221L48.4389 57.2622L46.1924 59.5087L43.8522 57.1686ZM39.172 52.4883L41.4185 50.2418L43.7586 52.5819L41.5121 54.8285L39.172 52.4883ZM34.4917 47.808L36.7382 45.5615L39.0783 47.9016L36.8318 50.1482L34.4917 47.808Z",
    fill: "#BEAEFF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8304 31.3542L52.8232 29.1699L55.0075 28.1771L52.8232 27.1842L51.8304 25L50.8376 27.1842L48.6533 28.1771L50.8376 29.1699L51.8304 31.3542Z",
    fill: "#BEAEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8315 38.7674L62.6517 34.763L66.6561 32.9428L62.6517 31.1226L60.8315 27.1182L59.0113 31.1226L55.0068 32.9428L59.0113 34.763L60.8315 38.7674Z",
    fill: "#BEAEFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9968_3792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.7708,
    height: 31.7708,
    fill: "white",
    transform: "translate(19 52.5352) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketIcon);
export default __webpack_public_path__ + "static/media/TicketIcon.4b608e4bd276d16a7c2ad2f5b7de7714.svg";
export { ForwardRef as ReactComponent };